import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2 } from 'lucide-react';
export function ProductOverview() {
  const features = ['+240 páginas de contenido estructurado', '60+ sesiones completas listas para dar', 'Técnica · Táctica · Físico · Arqueros · Planificación · Liderazgo', 'Funciona desde hoy mismo en tu cancha o club'];
  const levels = ['Principiante', 'Intermedio', 'Avanzado', 'Formativas', 'Amateur competitivo', 'Fútbol mixto'];
  return <Section className="bg-white" data-id="element-329">
      <div className="text-center max-w-4xl mx-auto" data-id="element-330">
        <div className="inline-flex items-center justify-center bg-gold/20 text-gold-dark px-4 py-1.5 rounded-full font-bold text-xs md:text-base mb-4 md:mb-8 border border-gold/30" data-id="element-331">
          🏆 Sistema N°1 para Instructores de Fútbol en Argentina
        </div>

        <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-dark mb-3 md:mb-6 tracking-tight" data-id="element-332">
          ⚽ MEGAPACK FÚTBOL RESUELTO™
          <span className="block text-primary mt-1 md:mt-2" data-id="element-333">
            SISTEMA COMPLETO
          </span>
        </h2>

        <p className="text-lg md:text-2xl font-bold text-gray-700 mb-6 md:mb-12" data-id="element-334">
          6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-8 md:mb-16 text-left" data-id="element-335">
          {features.map((feature, i) => <div key={i} className="flex items-center bg-gray-50 p-3 md:p-6 rounded-xl border border-gray-100 shadow-sm border-l-4 border-l-primary hover:bg-gray-100 transition-colors" data-id="element-336">
              <CheckCircle2 className="w-6 h-6 md:w-8 md:h-8 text-primary mr-3 md:mr-4 flex-shrink-0" data-id="element-337" />
              <span className="text-sm md:text-lg font-bold text-dark" data-id="element-338">
                {feature}
              </span>
            </div>)}
        </div>

        <div data-id="element-339">
          <h3 className="text-xl md:text-2xl font-bold text-dark mb-4 md:mb-6" data-id="element-340">
            Niveles y Enfoques Incluidos:
          </h3>
          <div className="flex flex-wrap justify-center gap-2 md:gap-3" data-id="element-341">
            {levels.map((level, i) => <span key={i} className="bg-dark text-white px-3 py-1.5 md:px-5 md:py-2.5 rounded-full font-semibold text-xs md:text-base shadow-md" data-id="element-342">
                ⚽ {level}
              </span>)}
          </div>
        </div>
      </div>
    </Section>;
}